export function captureScreenshot(PixelStreamingUiApp) {
  const videoPlayer = PixelStreamingUiApp?.stream.videoElementParent.querySelector("video");
  if (!videoPlayer) { console.error("Video element not found."); return; }
  if (videoPlayer.readyState < 2) { console.warn("Video is not ready yet."); return; }

  const canvas = document.createElement("canvas");
  canvas.width = videoPlayer.videoWidth;
  canvas.height = videoPlayer.videoHeight;
  canvas.getContext("2d").drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);

  const downloadLink = document.createElement("a");
  downloadLink.href = canvas.toDataURL("image/png");
  downloadLink.download = "pixelstream_screenshot.png";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}
